module.exports = "//public.getcloudapp.com/packs/media/images/download_icon_mac-b952b936172a4eefdf1007c36be5d836.svg";